// Extracted from `routesConfig.ts` so screens and pages can import route
// constants without pulling in the router's full screen graph, which was the
// root of a dense cycle set (`routesConfig` imports every screen, so any
// screen importing `appPaths` back closed a cycle).
export const appPaths = {
  admins: 'settings/admins',
  appReleases: 'settings/app-releases',
  config: 'settings/config',
  blockedPaymentMethods: 'blocked-payment-methods',
  cards: 'rewards/cards',
  fees: 'fees',
  forgotPassword: 'forgot-password',
  home: 'dashboard',
  kyc: 'kyc',
  login: 'login',
  notification: 'notification',
  processors: 'processors',
  rates: 'rates',
  referral: 'referral',
  rewards: 'rewards',
  settings: 'settings',
  setPassword: 'set-password',
  tiers: 'tiers',
  transactions: 'transactions',
  subscriptionPlans: 'subscription-plans',
  users: 'users',
  verifyOtp: 'verifyOtp',
  disputes: 'disputes',
  parameterStore: 'audit-logs/parameter-store',
  merchants: 'merchants',
  merchantMarketPlace: 'merchants/marketplace',
  merchantInvites: 'merchants/invitations',
  merchantAffiliate: 'merchants/affiliate',
  logs: 'user-logs',
  productUpdates: 'product-updates',
  // mansa: "mansa-liquidity"
};
